/**
 * Card Block hover State
 * Card Blockにdata-state="hover"をつける
 */

export function card_hover_state() {
	const selectors = [
		'.wp-block-houan-link-card[data-link-mode="card"]',
		'.wp-block-houan-media-card[data-link-mode="card"]',
	];

	const cards = document.querySelectorAll( selectors.join( ',' ) );

	cards.forEach( ( card ) => {
		const setHover = () => {
			card.setAttribute( 'data-state', 'hover' );
		};

		const removeHover = () => {
			card.removeAttribute( 'data-state' );
		};

		card.addEventListener( 'mouseenter', setHover );
		card.addEventListener( 'mouseleave', removeHover );
		card.addEventListener( 'focusin', setHover );
		card.addEventListener( 'focusout', ( event ) => {
			if ( ! card.contains( event.relatedTarget ) ) {
				removeHover();
			}
		} );
	} );
}
